// `User-Agent` is a forbidden request header per the Fetch spec — browsers
// silently drop it if set via fetch()/XHR — so it's sent under a custom
// header name the backend can read instead.
// Read at call time, not module load — in an SPA `window.location.href`
// changes via client-side routing without triggering a re-import.
export const getUserAgentHeaders = (): HeadersInit => ({
  "X-User-Agent": navigator.userAgent,
  "X-User-Platform": navigator.platform,
  "X-User-Origin": window.location.href
});
